import React from "react";

const RadioInput = ({
  inputName,
  id,
  value,
  onChangeFn,
  checked,
  className,
  defaultChecked = false,
  labelText,
}) => {
  return (
    <div className="input-wrapper">
      <input
        name={inputName}
        type="radio"
        id={id}
        value={value}
        defaultChecked={defaultChecked}
        onChange={(e) => onChangeFn(e)}
        checked={checked}
        className={className}
      />

      <label htmlFor={id} className="radio-input">
        <span className="radio" />
        {labelText && <span className="text">{labelText}</span>}
      </label>
    </div>
  );
};

export default RadioInput;
